import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import brandReducer from './slices/brandSlice';
import dealReducer from './slices/dealSlice';
import deliverableReducer from './slices/deliverableSlice';
import noteReducer from './slices/noteSlice';
import uiReducer from './slices/uiSlice';
import activityReducer from './slices/activitySlice';
import dashboardReducer from './slices/dashboardSlice';
import dashboardSettingsReducer from './slices/dashboardSettingsSlice';
import dashboardWidgetsReducer from './slices/dashboardWidgetsSlice';
import skuReducer from './slices/skuSlice';
import impersonationReducer from './slices/impersonationSlice';
import featureRequestReducer from './slices/featureRequestSlice';

/**
 * Redux Store Configuration
 *
 * Configured with Redux Toolkit for simplified Redux usage
 */
export const store = configureStore({
  reducer: {
    auth: authReducer,
    brands: brandReducer,
    deals: dealReducer,
    deliverables: deliverableReducer,
    notes: noteReducer,
    ui: uiReducer,
    activity: activityReducer,
    dashboard: dashboardReducer,
    dashboardSettings: dashboardSettingsReducer,
    dashboardWidgets: dashboardWidgetsReducer,
    skus: skuReducer,
    impersonation: impersonationReducer,
    featureRequests: featureRequestReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['auth/validateSession'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
        // Ignore these paths in the state
        ignoredPaths: ['items.dates'],
      },
    }),
  devTools: import.meta.env.MODE !== 'production',
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
